export const ADD_BOOKS = "ADD_BOOKS";
export const CLEAR_BOOKS = "CLEAR_BOOKS";
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_BOOK_FILTER = "SET_BOOK_FILTER";
export const SET_BOOKS_LOADING = "SET_BOOKS_LOADING";
export const SET_BOOK_LOADING_ERROR = "SET_BOOK_LOADING_ERROR";
export const SET_LAST_DEVICE_ID = "SET_LAST_DEVICE_ID";
